import { render, staticRenderFns } from "./DeploymentServerTable.vue?vue&type=template&id=444414a2"
import script from "./DeploymentServerTable.vue?vue&type=script&lang=js"
export * from "./DeploymentServerTable.vue?vue&type=script&lang=js"
import style0 from "./DeploymentServerTable.vue?vue&type=style&index=0&id=444414a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports